import { render, staticRenderFns } from "./viewService.vue?vue&type=template&id=b16834d0&scoped=true&"
import script from "./viewService.vue?vue&type=script&lang=js&"
export * from "./viewService.vue?vue&type=script&lang=js&"
import style0 from "./viewService.vue?vue&type=style&index=0&id=b16834d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16834d0",
  null
  
)

export default component.exports